const convertToLocalTime = (date) => {
  const localDate = new Date(
    date.getTime() - date.getTimezoneOffset() * 60 * 1000
  );

  return localDate.toISOString().split('T')[0];
};

export default convertToLocalTime;
